import BaseApi from './base.api'
import ApiService from "@services/api.service";

export default {
    ...BaseApi,
    ...{
        resource: 'invoices'
    },
    getDailyCollectionReport(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCollection`, params)
    },
    getDailyCollectionV2Report(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCollectionV2`, params)
    },
    getDailyCollectionV2AdmissionInvoices(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCollectionV2/admission-invoices`, params)
    },
    getCollectionReport(params = null) {
        return ApiService.get(`/${this.resource}/report/Collections`, params)
    },
    getDailyCreditReport(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCredit`, params)
    },
    getDailyCreditReportV2(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCreditV2`, params)
    },
    documentsPrint(params = null) {
        return ApiService.get(`/${this.resource}/documents-print`, params)
    },
    getParentsPaymentsReport(params = null) {
        return ApiService.get(`/${this.resource}/report/parentsPayments`, params)
    },
    getRefundCollectionReport(params = null) {
        return ApiService.get(`/${this.resource}/report/refundCollections`, params)
    },
    getParentStatementReport(params = null) {
        return ApiService.get(`/${this.resource}/report/parentStatement`, params)
    },
    getParentCreditReport(params = null) {
        return ApiService.get(`/${this.resource}/report/family-credit`, params)
    },

    getParentReport(params = null) {
        return ApiService.get(`/${this.resource}/report/parent`, params)
    },
    getParentTypeReport(params = null) {
        return ApiService.get(`/${this.resource}/report/parentTypes`, params)
    },
    getParentTotalInvoices(params = null) {
        return ApiService.get(`/${this.resource}/report/parentsTotalInvoices`, params)
    },
    getStudentTotalInvoices(params = null) {
        return ApiService.get(`/${this.resource}/report/studentsTotalInvoices`, params)
    },
    getDelayedInvoicesReport(params = null) {
        return ApiService.get(`/${this.resource}/report/delayedInvoices`, params)
    },
    getStudentReport(params = null) {
        return ApiService.get(`/${this.resource}/report/student`, params)
    },
    getWithdrawalReport(params = null) {
        return ApiService.get(`/${this.resource}/report/withdrawal`, params)
    },
    getDailyCreditUsers(params = null) {
        return ApiService.get(`/${this.resource}/report/users`, params)
    },
    getRefundUsers(params = null) {
        return ApiService.get(`/${this.resource}/report/refundUsers`, params)
    },
    getYearLevelDailyCreditReport(params = null) {
        return ApiService.get(`/${this.resource}/report/yearLevelDailyCredit`, params)
    },
    getWithdrawalUsersReport(params = null) {
        return ApiService.get(`/${this.resource}/report/withdrawal-users`, params)
    },
    getWithdrawalStudentsReport(params = null) {
        return ApiService.get(`/${this.resource}/report/withdrawal-students`, params)
    },
    getDiscountReport(params = null) {
        return ApiService.get(`/${this.resource}/report/discount`, params)
    },
    getBillingUsers(params = null) {
        return ApiService.get(`/${this.resource}/report/billing-users`, params)
    },
    getWithdrawalStudentsReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/withdrawal-students/excel`, params)
    },
    getDailyCollectionReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCollection/excel`, params)
    },
    getDailyCollectionV2ReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCollectionV2/excel`, params)
    },
    getDailyCollectionV2AdmissionInvoicesExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/DailyCollectionV2/admission-invoices/excel`, params)
    },
    getParentReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/parent/excel`, params)
    },
    getDiscountReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/discount/excel`, params)
    },
    getDelayedInvoicesReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/delayedInvoices/excel`, params)
    },
    getStudentReportExport(params = null) {
        return ApiService.get(`/${this.resource}/report/student/export`, params)
    },
    getStudentBalanceWithInstallmentsReportExport(params = null) {
        return ApiService.get(`/${this.resource}/report/student-balance-with-installments/export`, params)
    },
    getPaymentMethods(params = null) {
        return ApiService.get(`/${this.resource}/payment-methods`, params)
    },
    getPaymentTypes(params = null) {
        return ApiService.get(`/${this.resource}/payment-types`, params)
    },
    getRefundReport(params = null) {
        return ApiService.get(`/${this.resource}/report/refundReport`, params)
    },
    certificateReservation(params = null) {
        return ApiService.get(`/${this.resource}/report/certificate-reservation`, params)
    },
    certificateReservationExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/certificate-reservation-excel`, params)
    },
    getStudentStatementReport(params = null) {
        return ApiService.get(`/${this.resource}/report/student-statement-report`, params)
    },
    getParentStatementReportDetails(params = null) {
        return ApiService.get(`/${this.resource}/report/parent-statement-report`, params)
    },
    getStudentBalanceReport(params = null) {
        return ApiService.get(`/${this.resource}/report/student-balance-report`, params)
    },
    getStudentBalanceReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/student-balance-report/excel`, params)
    },
    getStudentBalanceReportWithInstallments(params = null) {
        return ApiService.get(`/${this.resource}/report/student-balance-report-with-installments`, params)
    },
    getStudentDataReport(params = null) {
        return ApiService.get(`/${this.resource}/report/student-data-report`, params)
    },
    getStudentDataReportExport(params = null) {
        return ApiService.get(`/${this.resource}/report/student-data-report/excel`, params)
    },
    getYearLevelClassBalanceReport(params = null) {
        return ApiService.get(`/${this.resource}/report/year-level-class-balance-report`, params)
    },
    getYearLevelClassBalanceReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/year-level-class-balance-report/excel`, params)
    },
    getStageYearLevelBalanceReport(params = null) {
        return ApiService.get(`/${this.resource}/report/stage-balance-report`, params)
    },
    getStageYearLevelBalanceReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/stage-balance-report/excel`, params)
    },
    getClassStudentsReport(params = null) {
        return ApiService.get(`/${this.resource}/report/get-class-students-report`, params)
    },
    getTotalIncomePerUserReport(params = null) {
        return ApiService.get(`/${this.resource}/report/get-total-income-per-user-report`, params)
    },
    getInvoiceMonthlyReport(params = null) {
        return ApiService.get(`/${this.resource}/report/monthly`, params)
    },
    getInvoiceMethodUserReport(params = null) {
        return ApiService.get(`/${this.resource}/report/user-method`, params)
    },
    getInvoiceMethodUserReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/user-method-excel`, params)
    },
    getFundedStudentsReport(params = null) {
        return ApiService.get(`/${this.resource}/report/funded-students`, params)
    },
    getFundedStudentsReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/funded-students-excel`, params)
    },
    payPrint(params = null) {
        return ApiService.get(`/${this.resource}/report/pay-print`, params)
    },

    getStudentCreditReport(params = null) {
        return ApiService.get(`/${this.resource}/report/students-credits-report`, params)
    },
    getStudentCreditReportExcel(params = null) {
        return ApiService.get(`/${this.resource}/report/students-credits-excel-report`, params)
    },
    getNextBillingReference(params = null) {
        return ApiService.get(`/${this.resource}/get-next-billing-reference`, params)
    },
    getRevenueReport(params = null) {
        return ApiService.get(`/${this.resource}/report/revenue-report`, params);
    },
    getStatementReceivablesReport(params = null) {
        return ApiService.get(`/${this.resource}/report/statement-receivables-report`, params);
    },
    getParentBalanceReport(params = null) {
        return ApiService.get(`/${this.resource}/report/parent-balance-report`, params)
    },
    getInvoices(params = null) {
        return ApiService.get(`/${this.resource}/get-invoices`, params)
    },

    getParentTotalAccountStatementReport(params = null) {
        return ApiService.get(`/${this.resource}/report/parent-total-account-statement-report`, params)
    },

    print(id, params = null) {
        return ApiService.post(`/${this.resource}/${id}/print`, params, {
            responseType: 'text',
            headers: {
                'Accept': 'text/html'
            }
        });
    },

     // === ZATCA METHODS ===
    
    getZatcaInvoiceLogReport(params = null) {
        return ApiService.get(`/${this.resource}/zatca/report`, params);
    },

    // Single Invoice Operations
    resendZatcaInvoice(invoiceId, params = null) {
        return ApiService.post(`/${this.resource}/zatca/${invoiceId}/resend`, params);
    },

    checkInvoiceStatus(invoiceId) {
        return ApiService.get(`/${this.resource}/zatca/invoices/${invoiceId}/status`);
    },

    bulkSyncZatca(invoiceIds) {
        return ApiService.post(`/${this.resource}/zatca/bulk-sync`, {
            invoice_ids: invoiceIds
        });
    },

    syncAllZatca(filters = {}) {
        return ApiService.post(`/${this.resource}/zatca/sync-all`, filters);
    },

    // NEW METHODS - School-specific Operations
    syncAllInvoicesForSchool(params = {}) {
        return ApiService.post(`/${this.resource}/zatca/schools/sync-all`, params);
    },

    resubmitFailedInvoicesForSchool(params = {}) {
        return ApiService.post(`/${this.resource}/zatca/schools/resubmit-failed`, params);
    },

    getZatcaSchoolStats(params = null) {
        return ApiService.get(`/${this.resource}/zatca/schools/stats`, params);
    },

    getZatcaQueueStatus() {
        return ApiService.get(`/${this.resource}/zatca/queue/status`);
    },

    bulkExportInvoices(invoiceIds) {
        return ApiService.post(`/${this.resource}/zatca/bulk-export`, {
            invoice_ids: invoiceIds
        }, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
    },

    exportAllInvoices(filters = {}) {
        return ApiService.post(`/${this.resource}/zatca/export-all`, filters);
    },

    exportSingleInvoice(invoiceId, params = null) {
        return ApiService.post(`/${this.resource}/zatca/${invoiceId}/export`, params, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
    },

    // Utility methods for ZATCA
    getZatcaStatuses() {
        return [
            { id: 'approved', name: 'Approved' },
            { id: 'rejected', name: 'Rejected' },
            { id: 'submitted', name: 'Submitted' }
        ];
    },

    getSyncStatuses() {
        return [
            { id: 'synced', name: 'Synced' },
            { id: 'not_synced', name: 'Not Synced' }
        ];
    },

    // === ZATCA REFUND PAYMENT METHODS ===
    
    submitZatcaRefund(refundPaymentId, params = null) {
        return ApiService.post(`${this.resource}/zatca/refunds/${refundPaymentId}/submit`, params);
    },

    getZatcaRefundStatus(refundPaymentId) {
        return ApiService.get(`${this.resource}/zatca/refunds/${refundPaymentId}/status`);
    },

    resendZatcaRefund(refundPaymentId, params = null) {
        return ApiService.post(`${this.resource}/zatca/refunds/${refundPaymentId}/resend`, params);
    },

    // === ZATCA ADMISSION PAYMENT METHODS ===
    
    submitZatcaAdmissionPayment(admissionPaymentId, params = null) {
        return ApiService.post(`${this.resource}/zatca/admission-payments/${admissionPaymentId}/submit`, params);
    },

    getZatcaAdmissionPaymentStatus(admissionPaymentId) {
        return ApiService.get(`${this.resource}/zatca/admission-payments/${admissionPaymentId}/status`);
    },

    resendZatcaAdmissionPayment(admissionPaymentId, params = null) {
        return ApiService.post(`${this.resource}/zatca/admission-payments/${admissionPaymentId}/resend`, params);
    }
}